import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "image"]

  connect() {
    this.preview()
  }

  disconnect() {
    URL.revokeObjectURL(this.objectURL)
  }

  preview() {
    URL.revokeObjectURL(this.objectURL)
    this.imageTarget.classList.add("hidden")
    this.imageTarget.removeAttribute("src")

    const file = this.inputTarget.files[0]
    if (!file || !["image/jpeg", "image/png", "image/webp"].includes(file.type)) return

    this.objectURL = URL.createObjectURL(file)
    this.imageTarget.src = this.objectURL
    this.imageTarget.classList.remove("hidden")
  }

  hide() {
    this.imageTarget.classList.add("hidden")
  }
}
